import { useForm } from "react-hook-form";
import { useSubmitCandidateCoachingStep } from "../logic";
import { notifyByMailModalResolver } from "../resolver";
import type { INotifyByEmailModalForm, TCandidateData } from "../types";

export const getEmailFormDefaultValues = (eligibleCandidates: readonly TCandidateData[]) => ({
  templateType: "",
  recipients: [...eligibleCandidates],
  cc: [],
  subject: "",
  attachments: [],
  content: {
    text: "",
    html: "",
  },
});

export const useSubmitEmail = (
  onSubmit: (data: INotifyByEmailModalForm) => Promise<void>,
  onSuccessEmail?: () => Promise<void> | void
) => {
  const updateCandidate = useSubmitCandidateCoachingStep();

  const submitEmail = async (data: INotifyByEmailModalForm) => {
    await onSubmit(data);
    await updateCandidate.submitCandidateCoachingStep(
      data.recipients.map((el) => el._id),
      data.coachingStep
    );
    if (onSuccessEmail) {
      await onSuccessEmail();
    }
  };
  return { updateEmailLoading: updateCandidate.loading, submitEmail };
};

export const useNotifyByEmailModalForm = (eligibleCandidates: readonly TCandidateData[]) => {
  const { control, handleSubmit, setValue, reset, getValues } = useForm<
    INotifyByEmailModalForm,
    void,
    INotifyByEmailModalForm
  >({
    // biome-ignore lint/suspicious/noExplicitAny:
    resolver: notifyByMailModalResolver as unknown as any,
    defaultValues: getEmailFormDefaultValues(eligibleCandidates),
  });
  return {
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
  };
};
